import { ref, computed } from 'vue';
import { Toast } from 'vant';
import { getCourseTabs } from '@/api/home';
import { getDepId } from '@/api/user';
import { getUserId, getUrlParam, appPort, getClassType } from '@/widget';
import { find, findIndex } from 'lodash-es';
import { storage } from '@/widget/Storage';
import { getCourseList } from '@/api/home';
// import router from '@/router'
const isApp = appPort();
const pathName = location.pathname;
// 会员选择
const vipList = ref([]);
const activeVip = ref();
export const useVipList = () => {
    const selectVip = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeVip.value?.id != item.id) {
            activeVip.value = item;
            fn && fn();
            getCourse(true);
        }
    };
    return {
        vipList,
        selectVip,
        activeVip
    };
};
// 招生状态
const enrollList = ref([]);
const activeEnroll = ref({});
// 课程类型
const typeList = ref([]);
const activeType = ref();
const typeInd = ref(0);
export const activeSubType = ref();
export const useCourseType = () => {
    const selectType = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeType.value?.id != item.id) {
            activeType.value = item;
            activeSubType.value = item.detailTypeList[0];
            if (item.id !== 'omo') {
                activeComing.value = comingList.value[0];
                activeEnroll.value = enrollList.value[0];
            }
            fn && fn();
            setActiveInd();
            getCourse(true);
        }
    };
    // 选择
    const selectSubType = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeSubType.value?.id != item.id) {
            activeSubType.value = item;
            if (item.id != 'online') {
                activeEnroll.value = enrollList.value[0];
                activeComing.value = comingList.value[0];
            }
            fn && fn();
            getCourse(true);
        }
    };
    return {
        activeType,
        selectType,
        typeList,
        activeSubType,
        selectSubType,
        typeInd
    };
};
// 亚专业
const subDepList = ref([]);
const activeSubDep = ref();
const activeMeta = ref();
const subDepInd = ref(0); // 亚专业选中行
const isVip188 = ref(false);
export const setVip188 = (item) => {
    isVip188.value = item;
};
export const useSubDep = () => {
    const selectSubDep = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeSubDep.value?.id !== item.id) {
            activeSubDep.value = item;
            activeMeta.value = item.knowledgeElementList[0];
            setActiveInd();
            fn && fn();
            getCourse(true);
        }
    };
    const selectMeta = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeMeta.value?.id !== item.id) {
            activeMeta.value = item;
            fn && fn();
            getCourse(true);
        }
    };
    return {
        activeSubDep,
        selectSubDep,
        subDepList,
        activeMeta,
        selectMeta,
        subDepInd
    };
};
// 排序
const rankList = ref([]);
const activeRank = ref();
export const useRank = () => {
    const selectRank = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeRank.value?.id !== item.id) {
            activeRank.value = item;
            fn && fn();
            getCourse(true);
        }
    };
    return { selectRank, activeRank, rankList };
};
// 报名状态
const buyList = ref([]);
const activeBuy = ref();
export const useBuy = () => {
    const selectBuy = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        if (activeBuy.value?.id !== item.id) {
            activeBuy.value = item;
            fn && fn();
            getCourse(true);
        }
    };
    return { selectBuy, activeBuy, buyList };
};
// 召开状态
export const comingList = ref([]);
export const activeComing = ref();
export const selectComing = (item, fn) => {
    if (courseLoading.value) {
        Toast('加载中，请稍后');
        return;
    }
    fn && fn();
    activeComing.value = item;
    activeEnroll.value = enrollList.value[0] || { id: '', name: '全部' };
    getCourse(true);
};
let userId = getUserId();
export const loading = ref(true);
const getTabs = (depId) => {
    let data = storage.get('tabList' + depId + '_' + isVip188.value);
    window.gio && window.gio('page.set', { dep_id: depId });
    if (data) {
        subDepList.value = data.subspecialtyList;
        typeList.value = data.typeList;
        vipList.value = data.vipList;
        buyList.value = data.buyList;
        rankList.value = data.rankList;
        comingList.value = data.comingList;
        enrollList.value = data.enrollStudentsList;
        setActiveItem();
    }
    else {
        getCourseTabs(userId, {
            departmentId: depId,
            isVip188: isVip188.value
        }).then((res) => {
            if (res.code == 200) {
                let data = res.data;
                subDepList.value = res.data.subspecialtyList;
                typeList.value = res.data.typeList;
                vipList.value = res.data.vipList;
                buyList.value = data.buyList;
                rankList.value = data.rankList;
                comingList.value = data.comingList;
                enrollList.value = data.enrollStudentsList;
                // 本地存放请求结果
                storage.set('tabList' + depId + '_' + isVip188.value, res.data, 60);
                setActiveItem();
            }
        });
    }
};
// 重置搜索
export const resetSearch = (fn) => {
    if (courseLoading.value) {
        Toast('加载中，请稍后');
        return;
    }
    // 页面判断
    activeVip.value = vipList.value[0];
    activeSubDep.value = subDepList.value[0];
    activeMeta.value = activeSubDep.value.knowledgeElementList[0];
    // 页面判断
    if (pathName == '/learn/course/master_class') {
        activeType.value = find(typeList.value, { id: 'master_class' });
    }
    else if (pathName == '/learn/course/open') {
        activeType.value = find(typeList.value, { id: 'open' });
    }
    else if (pathName == '/learn/course/omo') {
        activeType.value = find(typeList.value, { id: 'omo' });
    }
    else {
        activeType.value = typeList.value[0];
    }
    activeSubType.value = activeType.value?.detailTypeList[0];
    activeBuy.value = buyList.value[0];
    activeComing.value = comingList.value[0];
    if (rankList.value) {
        activeRank.value = rankList.value[0];
    }
    activeEnroll.value = enrollList.value[0];
    fn && fn();
    getCourse(true);
};
const toNumber = (num) => {
    let n = Number(num || 0);
    if (isNaN(n)) {
        return 0;
    }
    else {
        return n;
    }
};
export const totalCount = ref(0); // 总的课程数量
// 设置搜索选中项
export const setActiveItem = (data) => {
    let vipId;
    let metaId;
    let type;
    let subType;
    let coming;
    let rank;
    let buy;
    let subDep;
    let enroll;
    if (data) {
        courseLoaded.value = false;
        page = 1;
        totalCount.value = data.totalCount;
        activeData.value = data.activeData;
        if (data.courseList?.length) {
            courseList.value = data.courseList;
            setTimeout(() => {
                courseLoaded.value = true;
            });
        }
        else {
            getCourse(true);
        }
    }
    // if (!data) {
    //   data = storage.get('searchData')
    // }
    if (isApp && data) {
        let { activeVip, activeSubDep, activeMeta, activeType, activeSubType, activeRank, activeBuy, activeComing, activeEnroll } = data;
        vipId = toNumber(activeVip?.id || 0);
        metaId = toNumber(activeMeta?.id || 0);
        type = activeType?.id || '';
        subType = activeSubType?.id || 0 || '';
        coming = activeComing?.id || '';
        rank = activeRank?.id || '';
        buy = activeBuy?.id || '';
        subDep = activeSubDep?.id || 0;
        enroll = activeEnroll?.id || '';
    }
    else {
        vipId = toNumber(getUrlParam('vipId'));
        metaId = toNumber(getUrlParam('metaId'));
        type = getUrlParam('type') || '';
        subType = getUrlParam('subType') || '';
        coming = getUrlParam('coming') || '';
        rank = getUrlParam('rank') || '';
        buy = getUrlParam('buy') || '';
        subDep = toNumber(getUrlParam('subDep') || 0);
        enroll = getUrlParam('enroll') || '';
    }
    activeVip.value = find(vipList.value, { id: vipId }) || vipList.value[0];
    activeSubDep.value =
        find(subDepList.value, { id: subDep }) || subDepList.value[0];
    activeMeta.value =
        find(activeSubDep.value?.knowledgeElementList, { id: metaId }) ||
            activeSubDep.value?.knowledgeElementList[0] ||
            {};
    activeType.value = find(typeList.value, { id: type }) || typeList.value[0];
    // 页面判断
    if (pathName == '/learn/course/master_class') {
        activeType.value = find(typeList.value, { id: 'master_class' });
        activeVip.value = vipList.value[0];
    }
    else if (pathName == '/learn/course/open') {
        activeType.value = find(typeList.value, { id: 'open' });
        activeVip.value = vipList.value[0];
    }
    else if (pathName == '/learn/course/omo') {
        if (coming) {
            var n = Number(coming);
            coming = isNaN(n) ? 1 : n;
        }
        else {
            coming = 1;
        }
        activeType.value = find(typeList.value, { id: 'omo' });
        activeVip.value = vipList.value[0];
    }
    if (coming) {
        var n = Number(coming);
        coming = isNaN(n) ? '' : n;
    }
    let detailType = activeType.value?.detailTypeList || [];
    activeSubType.value = find(detailType, { id: subType }) || detailType[0];
    activeBuy.value = find(buyList.value, { id: buy }) || buyList.value[0];
    activeEnroll.value =
        find(enrollList.value, { id: enroll }) || enrollList.value[0];
    // TODO 数据暂时没有
    if (rankList.value) {
        activeRank.value = find(rankList.value, { id: rank }) || rankList.value[0];
    }
    activeComing.value =
        find(comingList.value, { id: coming }) || comingList.value[0];
    // 加载完成
    setActiveInd();
    loading.value = false;
};
// 是否有筛选项
export const activeFilter = computed(() => {
    if (pathName != '/learn/course') {
        return (activeBuy.value?.id ||
            activeRank.value?.id == 'hot' ||
            !!activeEnroll.value.id);
    }
    else {
        return (activeComing.value?.id !== '' ||
            activeBuy.value?.id ||
            activeRank.value?.id == 'hot' ||
            !!activeEnroll.value.id);
    }
});
// 设置筛选中展示项
const setActiveInd = () => {
    typeInd.value = Math.ceil((findIndex(typeList.value, { id: activeType.value?.id }) || 0) / 3);
    subDepInd.value = Math.ceil((findIndex(subDepList.value, { id: activeSubDep.value?.id }) || 0) / 3);
};
// 获取科室信息
export const depId = ref(Number(getUrlParam('depId') || 0));
export const initFn = () => {
    if (isApp) {
        getDepId(userId).then((res) => {
            if (res.code == 200) {
                depId.value = res.data.depId;
                getTabs(depId.value);
            }
        });
    }
    else {
        if (depId.value) {
            getTabs(depId.value);
        }
        else {
            getDepId(userId).then((res) => {
                if (res.code == 200) {
                    depId.value = res.data.depId;
                    getTabs(depId.value);
                }
            });
        }
    }
};
export const useEnroll = () => {
    const selectEnroll = (item, fn) => {
        if (courseLoading.value) {
            Toast('加载中，请稍后');
            return;
        }
        fn && fn();
        activeEnroll.value = item;
        getCourse(true);
    };
    return {
        enrollList,
        activeEnroll,
        selectEnroll
    };
};
// 获取课程
const courseList = ref([]);
const courseLoaded = ref(false);
let page = 1;
let pageCount = 1;
const noMore = ref(false);
export const courseLoading = ref(false);
export const activeData = ref();
export const getCourse = (bl) => {
    if (noMore.value && !bl) {
        // 上拉加载完后不再继续加载
        return;
    }
    let vipId = activeVip.value?.id || 0;
    let type = '';
    if (pathName == '/learn/course/master_class') {
        type = 'master_class';
    }
    else if (pathName == '/learn/course/open') {
        type = 'open';
    }
    else if (pathName == '/learn/course/omo') {
        type = 'omo';
    }
    else {
        type = activeType.value?.id || '';
    }
    let detailType = activeSubType.value?.id || '';
    let subspecialtyId = activeSubDep.value?.id || 0;
    let knowledgeElementId = activeMeta.value?.id || 0;
    let departmentId = depId.value || 1;
    let isBuy = activeBuy.value?.id || '';
    let rank = activeRank.value?.id || '';
    let isComing = activeComing.value?.id === undefined ? '' : activeComing.value.id;
    let enroll = '';
    if (activeSubType.value?.id == 'online' || activeType.value?.id == 'omo') {
        enroll = activeEnroll.value.id;
    }
    if (courseLoading.value) {
        Toast('加载中，请稍后');
        return;
    }
    courseLoading.value = true;
    courseLoaded.value = false;
    // app 保存本地文件
    activeData.value = {
        vipId: vipId,
        metaId: subspecialtyId,
        type,
        subType: detailType,
        coming: isComing,
        rank,
        buy: isBuy,
        subDep: subspecialtyId
    };
    if (bl) {
        page = 1;
    }
    // if (bl && pathName == '/learn/course') {
    //   router.replace({
    //     path: '/course',
    //     query: {
    //       vipId: vipId,
    //       metaId: subspecialtyId,
    //       type,
    //       subType: detailType,
    //       coming: isComing,
    //       rank,
    //       buy: isBuy,
    //       subDep: subspecialtyId,
    //       enroll
    //     }
    //   })
    // }
    let params = {
        vipId,
        type,
        departmentId,
        subspecialtyId,
        detailType,
        knowledgeElementId,
        pageNo: page,
        pageSize: 20,
        isBuy,
        rank,
        isComing,
        enroll,
        isVip188: isVip188.value
    };
    if (isVip188.value && (vipId == 2 || vipId == 3)) {
        params = {
            vipId,
            type: "",
            departmentId,
            subspecialtyId: Number(),
            detailType: "",
            knowledgeElementId: Number(),
            pageNo: page,
            pageSize: 20,
            isBuy: "",
            rank,
            isComing: "",
            enroll: "",
            isVip188: isVip188.value
        };
    }
    getCourseList(userId, params).then((res) => {
        courseLoading.value = false;
        if (res.code == 200) {
            totalCount.value = res.data.totalCount;
            pageCount = res.data.pageCount;
            if (page == 1) {
                courseList.value = res.data.list;
            }
            else {
                res.data.list.forEach(element => {
                    courseList.value.push(element);
                });
            }
            if (isApp) {
                localStorage.setItem('totalCount', totalCount.value + '');
                localStorage.setItem('courseList', JSON.stringify(courseList.value));
            }
            if (pageCount > page) {
                page++;
                noMore.value = false;
            }
            else {
                noMore.value = true;
            }
        }
        courseLoaded.value = true;
    });
};
export const useCourseData = () => {
    return {
        courseList,
        courseLoaded,
        noMore,
        getCourse
    };
};
// 保存数据
export const saveData = () => {
    if (isApp) {
        storage.set('searchData', {
            comingList: comingList.value,
            activeVip: activeVip.value,
            activeSubDep: activeSubDep.value,
            activeMeta: activeMeta.value,
            activeType: activeType.value,
            activeSubType: activeSubType.value,
            activeRank: activeRank.value,
            activeBuy: activeBuy.value,
            activeComing: activeComing.value
        }, null);
    }
};
// app 交互传惨
export const sendLocalData = () => {
    if (!courseList.value) {
        courseList.value = JSON.parse(localStorage.getItem('courseList') || '');
    }
    getClassType(JSON.stringify({
        comingList: comingList.value,
        activeVip: activeVip.value,
        activeSubDep: activeSubDep.value,
        activeMeta: activeMeta.value,
        activeType: activeType.value,
        activeSubType: activeSubType.value,
        activeRank: activeRank.value,
        activeBuy: activeBuy.value,
        activeComing: activeComing.value,
        courseList: courseList.value,
        totalCount: totalCount.value,
        activeData: activeData.value
    }));
};
